import Mock from './Mock';

export default class ActivityAreaServiceMock {
  static getActivtyAreas() {
    return Mock.call();
  }

  static getActivityAreaById() {
    return Mock.call();
  }
}
